import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {accessConstants, authUtils} from "mindsets-js-sdk";
import {InvalidateProjectCacheAction} from "../../../actions/project_actions";


function InvalidateProjectButton({id}) {
    const me = useSelector(state => state.me);
    const dispatch = useDispatch();
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_PROJECTS])) {
        return (
            <button
                className='button warning'
                onClick={() => {
                    dispatch(InvalidateProjectCacheAction(id));
                }}
            >
                Invalidate cache
            </button>
        );
    }

    return null;
}

InvalidateProjectButton.propTypes = {
    id: PropTypes.number.isRequired
}

export default InvalidateProjectButton;
